<template>
  <div class="filter-shortcuts">
    <div class="buttonContainer">
      <a v-for="filter in filters" :key="filter.filterTitle" :href="buildRoute(filter)" @click="filterClicked(filter)" :aria-label="isSelected(filter) ? 'Remove Filter' : 'Apply Filter'" :disabled="!isSelected(filter) && !!selectedFilter">
        <SelectableButton :label="filter.filterTitle" :active="isSelected(filter)" />
      </a>
    </div>
  </div>
</template>

<script src="./filter-shortcuts.js"></script>

<style lang="scss">
@use "./filter-shortcuts.scss" as *;
</style>
